function validateViewTag(viewTag) {
  if (!Number.isInteger(viewTag) || viewTag < 1 || viewTag > 2147483647) throw new TypeError("ScreenCapture.captureView requires a positive 32-bit integer view tag");
}
var preventDefaultKey = "default";
function assertPreventKey(key, verb) {
  if (typeof key !== "string" || key.length === 0) throw new TypeError(`ScreenCapture.${verb} requires a non-empty string key`);
}
export {
  assertPreventKey,
  preventDefaultKey,
  validateViewTag
};
//# sourceMappingURL=validate.js.map
